import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-translate-component';
import { withState } from 'recompose';
import { prop, pathOr, equals, slice } from 'ramda';

import withFieldWrapper from 'components/hocs/withFieldWrapper';
import withFormProps from 'components/hocs/withFormProps';
import withLoad from 'components/hocs/withLoad';
import { SelectBase } from 'components/common/form/Select';

class SearchInput extends Component {
    static propTypes = {
        input: PropTypes.object,
        form: PropTypes.object,
        onChange: PropTypes.func.isRequired,
        options: PropTypes.array,
        namePath: PropTypes.string,
        valuePath: PropTypes.string,
        inputTextPlaceholder: PropTypes.string,
        placeholderDefault: PropTypes.bool,
        placeholder: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element
        ]),
        pending: PropTypes.bool,
        allowClear: PropTypes.bool,
        onSearch: PropTypes.func.isRequired,
    };

    static defaultProps = {
        options: [],
        namePath: 'name',
        valuePath: 'id',
        inputTextPlaceholder: 'placeholders.inputText',
    };

    state = {
        inputText: ''
    }

    onInputChange = (inputText = '') => {
        const { onSearch } = this.props;

        onSearch(inputText.length > 2 && inputText);
        this.setState({ inputText });

        return inputText;
    }

    onChange = (value, option) => {
        this.setState({ inputText: '' });
        this.props.onChange(value, option);
        this.props.form.change(`${this.props.input.name}Placeholder`, pathOr(null, ['data', this.props.namePath], option))
    }

    getNotFoundContent() {
        const { pending, inputTextPlaceholder } = this.props;

        if (pending) {
            return null;
        }

        const { inputText } = this.state;

        return inputText.length > 2 ? translate('errors.notFound') : translate(inputTextPlaceholder);
    }

    render() {
        const { placeholder, placeholderDefault, allowClear, inputTextPlaceholder, options = [], namePath, valuePath, pending, input: { value } } = this.props;

        const selectOptions = this.state.inputText ? options : ([
            { [namePath]: translate(inputTextPlaceholder), disabled: true },
            ...options,
        ]);

        return (
            <SelectBase
                showSearch
                options={selectOptions}
                namePath={namePath}
                valuePath={valuePath}
                value={value}
                placeholder={placeholder}
                placeholderDefault={placeholderDefault}
                notFoundContent={this.getNotFoundContent()}
                onSearch={this.onInputChange}
                loading={pending}
                onChange={this.onChange}
                allowClear={allowClear}
            />
        );
    }
}

export default withFieldWrapper(withFormProps(SearchInput));

const getDefaultSearch = (props) => {
    const defaultSearch = prop('defaultSearch', props);

    if (defaultSearch) {
        return slice(0, 3, defaultSearch);
    } else {
        return '';
    }
};

const SearchInputWithLoad = withLoad(SearchInput);
export const SearchInputLoaded = withFieldWrapper(withFormProps(
    withState('loadParams', 'setLoadParams', props => props.searchLoadParams(getDefaultSearch(props)))(
        props => (
            <SearchInputWithLoad
                {...props}
                onSearch={search => {
                    let defaultSearch = getDefaultSearch(props);

                    if (search || !equals(props.loadParams, props.searchLoadParams(defaultSearch))) {
                        props.setLoadParams(props.searchLoadParams(search || defaultSearch));
                    }
                }}
            />
        )
    )
));
